import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

// Pages load on first visit, so the app starts fast.
const BoardPage = lazy(() => import("./web/BoardPage.js").then((m) => ({ default: m.BoardPage })));
const DayPage = lazy(() => import("./web/DayPage.js").then((m) => ({ default: m.DayPage })));
const SignOffPage = lazy(() => import("./web/SignOffPage.js").then((m) => ({ default: m.SignOffPage })));
const CrsPage = lazy(() => import("./web/SignOffPage.js").then((m) => ({ default: () => <m.SignOffPage mode="crs" /> })));
const SrsPage = lazy(() => import("./web/SignOffPage.js").then((m) => ({ default: () => <m.SignOffPage mode="srs" /> })));
const SettingsPage = lazy(() => import("./web/SettingsPage.js").then((m) => ({ default: m.SettingsPage })));
// Fuel review C: fuel invoices are part of the Cash Office (on the fuel part's data).
const FuelInvoicesPage = lazy(() => import("./web/FuelInvoicesPage.js").then((m) => ({ default: m.FuelInvoicesPage })));

export default defineWebModule({ manifest, pages: { "": BoardPage, "/day": DayPage, "/sign-off": SignOffPage, "/crs": CrsPage, "/srs": SrsPage, "/settings": SettingsPage, "/fuel-invoices": FuelInvoicesPage } });
